<div class="content-wrapper" *ngIf="currentReport">

  <div class="row" id="REPORT_GENERAL_PAGE">
    <div class="col-md-8">
      <!-- Company Information -->
      <div class="section-block">
        <div class="section-header" (click)="isCollapsed.COMPANY = !isCollapsed.COMPANY"
          [attr.aria-expanded]="!isCollapsed.COMPANY" aria-controls="collapseEvent">
          <fa [name]="isCollapsed.COMPANY ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text">Company Information</div>
        </div>

        <div class="section-content" [collapse]="!isCollapsed.COMPANY">
          <ng-container *ngFor="let entity of currentReport.ENTITIES | orderBy: ['ORDER']; let i = index;">
            <div class="row">
              <div class="col-sm-12">
                <label class="rbv-label" [ngClass]="{'with-check': i === 0}">
                  <ng-container *ngIf="currentReport.IS_MULTIPLE_ENTITY === true">
                    {{i === 0 ? 'Primary Corporate Name' : ('Entity #'+ [i+1])}}
                  </ng-container>

                  <ng-container *ngIf="!(currentReport.IS_MULTIPLE_ENTITY === true)">
                    Corporate Name
                  </ng-container>

                  <label class="checkbox mb-0" *ngIf="i === 0">
                    <input type="checkbox" class="checkbox__input" name="isMultiple" id="isMultiple"
                      [checked]="currentReport.IS_MULTIPLE_ENTITY === true"
                      [disabled]="isDisabled || !isActiveEdit()">
                    <div class="checkbox__data pr-0" (click)="isMultipleChange($event)">
                      <div class="checkbox__indicator"></div>
                      <p class="checkbox__text"> Multiple Entity</p>
                    </div>
                  </label>
                </label>

                <div class="corp-name-wrapper">
                  <input-data [type]="typeOfInput.TEXT" [(ngModel)]="entity.NAME" [provider]="reportEntityProvider"
                    [id]="entity.ID" [fieldName]="'NAME'" [maxLength]="maxlength" placeholder="Entity Name"
                    [disabled]="isDisabled || !isActiveEdit()" (onValueTouched)="onValueTouched($event)"
                    [showButton]="showButton" [required]="true"></input-data>

                  <button [disabled]="isDisabled || !isActiveEdit()" type="button" class="btn btn-rbv info hinted"
                    (click)="addEntity()" *ngIf="i === 0 && currentReport.IS_MULTIPLE_ENTITY"
                    style="width: 122px; margin-left: 8px;">
                    <fa name="fa fa-plus"></fa> Entity
                    <div class="hint">Add Corporate Entity</div>
                  </button>

                  <button [disabled]="isDisabled || !isActiveEdit()" type="button"
                    class="btn btn-rbv warning remove-client-user hinted" (click)="removeEntity(entity)"
                    style="margin-left: 8px;" *ngIf="i > 0 && currentReport.IS_MULTIPLE_ENTITY">
                    <fa name="fa fa-ban"></fa>
                    <div class="hint">Remove Corporate Entity</div>
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <label class="rbv-label">
                  <ng-container *ngIf="currentReport.IS_MULTIPLE_ENTITY === true">
                    {{i === 0 ? 'Primary Corporate DBA Name' : ('Entity #'+ [i+1] + ' DBA Name')}}
                  </ng-container>

                  <ng-container *ngIf="!(currentReport.IS_MULTIPLE_ENTITY === true)">
                    DBA Name
                  </ng-container>
                </label>

                <input-data [type]="typeOfInput.TEXT" [(ngModel)]="entity.DBA" [provider]="reportEntityProvider"
                  [id]="entity.ID" [fieldName]="'DBA'" [maxLength]="maxlength"
                  [disabled]="isDisabled || !isActiveEdit()" (onValueTouched)="onValueTouched($event)"
                  (onSaveSuccess)="onValueSaved(entity)" [showButton]="showButton">
                </input-data>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <label> Business form of incorporation
                  <i [tooltip]="businessFormHelpText" class="fa fa-question-circle" [adaptivePosition]="false" placement="right"></i>
                </label>

                <input-search [preset]="entityTypes" [regular]="true" #entityType="ngModel" [(ngModel)]="entity.TYPE" name="entityType_{{i}}"
                  placeholder="Business` form of incorporation" (valueChange)="onBusinessFormValueChanged($event, entity)"
                  [disabled]="isDisabled || !isActiveEdit()" ></input-search>

              </div>
            </div>
          </ng-container>

          <div class="row">
            <div class="col-sm-12">
              <label class="rbv-label">
                Internal File Name
              </label>
              <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.INTERNAL_FILE_NAME"
                [provider]="reportProvider" [id]="currentReport.ID" [fieldName]="'INTERNAL_FILE_NAME'"
                [maxLength]="maxlength" [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"
                placeholder="Internal File Name">
              </input-data>
            </div>
          </div>

          <div class="row" *ngIf="currentReport.FILE_LOCATION">
            <div class="col-sm-12">
              <label class="rbv-label">
                File Location
              </label>

              <div class="file-wrapper">
                <div class="input-wrapper">
                  <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.FILE_LOCATION"
                    [provider]="reportProvider" [id]="currentReport.ID" [fieldName]="'FILE_LOCATION'"
                    [maxLength]="maxlength" [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"
                    placeholder="File Location">
                  </input-data>
                </div>

                <div class="copy-wrapper">
                  <span *ngIf="copied">Copied to buffer</span>

                  <button type="button" (click)="copy()">
                    <i class="fa fa-clipboard" aria-hidden="true" style="margin-right: 3px;"></i> Copy
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="currentReport.LL_NUMBER">
            <div class="col-sm-12">
              <label class="rbv-label">
                Liquor License Number
              </label>
              <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.LL_NUMBER"
                [provider]="reportProvider" [id]="currentReport.ID" [fieldName]="'LL_NUMBER'"
                [maxLength]="50" [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"
                placeholder="Liquore License Number">
              </input-data>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">

              <label class="checkbox mb-0" style="white-space: nowrap; margin-top: 5px;">
                <input type="checkbox" class="checkbox__input" name="isOverride" id="isOverride"
                  [(ngModel)]="currentReport.OVERRIDE" (ngModelChange)="isOverrideChange($event)"
                  [disabled]="isDisabled || !isActiveEdit()">
                <div class="checkbox__data pl-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"> Override </p>
                </div>
              </label>

            </div>
          </div>

          <div class="row" *ngIf="currentReport.OVERRIDE">
            <div class="col-sm-12">
              <label class="rbv-label">Override Name</label>
              <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.OVERRIDE_NAME"
                [provider]="reportProvider" [id]="currentReport.ID" [fieldName]="'OVERRIDE_NAME'"
                placeholder="Override Name" [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton">
              </input-data>
            </div>
          </div>
        </div>
      </div>

      <!-- Client Information -->
      <div class="section-block">
        <div class="section-header" [attr.aria-expanded]="!isCollapsed.CLIENT" aria-controls="collapseEvent">
          <fa [name]="isCollapsed.CLIENT ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text" (click)="isCollapsed.CLIENT = !isCollapsed.CLIENT">
            {{ currentReport?.CLIENT?.IS_BANK ? 'Client Information' : 'Bank Information' }}
            <notes-info [data]="currentReport.CLIENT"
              [disabled]="isDisabled || !currentReport.CLIENT || !isActiveEdit()"
              (updateNotes)="updateClientNotes($event)"></notes-info>
          </div>
        </div>

        <!-- BANK INFORMATION -->
        <div class="section-content" [collapse]="!isCollapsed.CLIENT">
          <!-- Client Name / Bank Name -->
          <div class="row">
            <div class="col-sm-10" style="padding-right: 5px;">
              <label class="rbv-label"> {{ currentReport?.CLIENT?.IS_BANK ? 'Group' : 'Bank Name' }} </label>
              <input-search [provider]="clientProvider" [showCreate]="true" [createNew]="typesOfData.CLIENT"
                placeholder="Select Bank" [inputValue]="currentReport.CLIENT" [refresh]="true" [paginated]="true"
                (valueChange)="selectedClient($event);" [disabled]="isDisabled || !isActiveEdit()"></input-search>
            </div>

            <div class="col-sm-2" style="padding-left: 2px;">
              <div class="toggle-button-row no-label">
                <profile-info [data]="currentReport.CLIENT" [profileInfoType]="ProfileInfoType.CLIENT"
                  [disabled]="isDisabled || !currentReport.CLIENT || !isActiveEdit()"
                  (updatedValueEmit)="updateEmittedValue($event)"></profile-info>
                <button [disabled]="isDisabled || !isActiveEdit()" type="button" class="btn btn-rbv info hinted"
                  (click)="addClientUser()" style="width: 85px;">
                  <fa name="fa fa-plus"></fa> User
                  <div class="hint">Add Bank User</div>
                </button>
              </div>
            </div>
          </div>

          <ng-container *ngIf="!currentReport?.CLIENT?.IS_BANK">
            <!-- Lender -->
            <div class="row">
              <div class="col-sm-10" style="padding-right: 5px;">
                <label class="rbv-label">Lender</label>
                <input-search [provider]="clientUserProvider" [showCreate]="true" [createNew]="typesOfData.CLIENT_USER"
                  placeholder="Select Client Processor"
                  [disabled]="isDisabled || !currentReport.CLIENT || !isActiveEdit()" [refresh]="true"
                  [displayFull]="true" [userIcon]="true" [parent-id]="currentReport.CLIENT?.ID"
                  [parent]="currentReport?.CLIENT" [inputValue]="getClientUserByType(ReportClientType.PROCESSOR)"
                  [paginated]="true" (valueChange)="selectedClientUser(ReportClientType.PROCESSOR, $event);">
                </input-search>
              </div>

              <div class="col-sm-2" style="padding-left: 2px;">
                <div class="toggle-button-row no-label">
                  <profile-info [data]="getClientUserByType(ReportClientType.PROCESSOR)"
                    [profileInfoType]="ProfileInfoType.CLIENT_USER"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.PROCESSOR) || !isActiveEdit()">
                  </profile-info>
                  <toggle-button icon="envelope-o" hint="CC on Correspondence"
                    [value]="getClientUserByType(ReportClientType.PROCESSOR)?.EMAIL_CC"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_CC', getClientUserByType(ReportClientType.PROCESSOR))"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.PROCESSOR) || !isActiveEdit()">
                  </toggle-button>
                  <toggle-button [show]="showAllToggleButton() || isShowEngagedLetter(ReportClientType.PROCESSOR)"
                    icon="paperclip" hint="Send Engagement Letter" [name]="ReportClientType.PROCESSOR"
                    [value]="getClientUserByType(ReportClientType.PROCESSOR)?.EMAIL_ENGAGE"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_ENGAGE', getClientUserByType(ReportClientType.PROCESSOR))"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.PROCESSOR) || !isActiveEdit()">
                  </toggle-button>
                </div>
              </div>
            </div>

            <!-- BDO -->
            <div class="row">
              <div class="col-sm-10" style="padding-right: 5px;">
                <label class="rbv-label">BDO</label>
                <input-search id="BDO_INPUT_SEARCH" [provider]="clientUserProvider" [showCreate]="true"
                  [createNew]="typesOfData.CLIENT_USER" placeholder="Select Client BDO"
                  [disabled]="isDisabled || !currentReport.CLIENT || !isActiveEdit()" [refresh]="true"
                  [displayFull]="true" [userIcon]="true" [parent-id]="currentReport.CLIENT?.ID"
                  [parent]="currentReport?.CLIENT" [inputValue]="getClientUserByType(ReportClientType.BDO)"
                  [paginated]="true" (valueChange)="selectedClientUser(ReportClientType.BDO, $event);"></input-search>
              </div>

              <div class="col-sm-2" style="padding-left: 2px;">
                <div class="toggle-button-row no-label">
                  <profile-info [data]="getClientUserByType(ReportClientType.BDO)"
                    [profileInfoType]="ProfileInfoType.CLIENT_USER"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.BDO) || !isActiveEdit()">
                  </profile-info>
                  <toggle-button icon="envelope-o" hint="CC on Correspondence"
                    [value]="getClientUserByType(ReportClientType.BDO)?.EMAIL_CC"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_CC', getClientUserByType(ReportClientType.BDO))"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.BDO) || !isActiveEdit()">
                  </toggle-button>
                  <toggle-button [show]="showAllToggleButton() || isShowEngagedLetter(ReportClientType.BDO)"
                    icon="paperclip" hint="Send Engagement Letter" [name]="ReportClientType.BDO"
                    [value]="getClientUserByType(ReportClientType.BDO)?.EMAIL_ENGAGE"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_ENGAGE', getClientUserByType(ReportClientType.BDO))"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.BDO) || !isActiveEdit()">
                  </toggle-button>
                </div>
              </div>
            </div>

            <!-- Underwriter -->
            <div class="row">
              <div class="col-sm-10" style="padding-right: 5px;">
                <label class="rbv-label">Underwriter</label>
                <input-search [provider]="clientUserProvider" [showCreate]="true" [createNew]="typesOfData.CLIENT_USER"
                  placeholder="Select Client Underwriter"
                  [disabled]="isDisabled || !currentReport.CLIENT || !isActiveEdit()" [refresh]="true"
                  [displayFull]="true" [userIcon]="true" [parent-id]="currentReport.CLIENT?.ID"
                  [parent]="currentReport?.CLIENT" [inputValue]="getClientUserByType(ReportClientType.UNDERWRITER)"
                  [paginated]="true" (valueChange)="selectedClientUser(ReportClientType.UNDERWRITER, $event);">
                </input-search>
              </div>

              <div class="col-sm-2" style="padding-left: 2px;">
                <div class="toggle-button-row no-label">
                  <profile-info [data]="getClientUserByType(ReportClientType.UNDERWRITER)"
                    [profileInfoType]="ProfileInfoType.CLIENT_USER"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.UNDERWRITER) || !isActiveEdit()">
                  </profile-info>
                  <toggle-button icon="envelope-o" hint="CC on Correspondence"
                    [value]="getClientUserByType(ReportClientType.UNDERWRITER)?.EMAIL_CC"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_CC', getClientUserByType(ReportClientType.UNDERWRITER))"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.UNDERWRITER) || !isActiveEdit()">
                  </toggle-button>
                  <toggle-button [show]="showAllToggleButton() || isShowEngagedLetter(ReportClientType.UNDERWRITER)"
                    icon="paperclip" hint="Send Engagement Letter" [name]="ReportClientType.UNDERWRITER"
                    [value]="getClientUserByType(ReportClientType.UNDERWRITER)?.EMAIL_ENGAGE"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_ENGAGE', getClientUserByType(ReportClientType.UNDERWRITER))"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.UNDERWRITER) || !isActiveEdit()">
                  </toggle-button>
                </div>
              </div>
            </div>

            <!-- Lender Service Providers -->
            <div class="row">
              <div class="col-sm-10" style="padding-right: 5px;">
                <label class="rbv-label">Lender Service Providers</label>
                <input-search id="LENDER_SERVICE_INPUT_SEARCH" [provider]="clientUserProvider" [showCreate]="true"
                  [createNew]="typesOfData.CLIENT_USER" placeholder="Select Lender Service Providers"
                  [disabled]="isDisabled || !currentReport.CLIENT || !isActiveEdit()" [refresh]="true"
                  [displayFull]="true" [userIcon]="true" [parent-id]="currentReport.CLIENT?.ID"
                  [parent]="currentReport?.CLIENT" [inputValue]="getClientUserByType(ReportClientType.LSP)"
                  [nonBank]="true" [lsp]="true" [paginated]="true"
                  (valueChange)="selectedClientUser(ReportClientType.LSP, $event);"></input-search>
              </div>

              <div class="col-sm-2" style="padding-left: 2px;">
                <div class="toggle-button-row no-label">
                  <profile-info [data]="getClientUserByType(ReportClientType.LSP)"
                    [profileInfoType]="ProfileInfoType.CLIENT_USER"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.LSP) || !isActiveEdit()">
                  </profile-info>
                  <toggle-button icon="envelope-o" hint="CC on Correspondence"
                    [value]="getClientUserByType(ReportClientType.LSP)?.EMAIL_CC"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_CC', getClientUserByType(ReportClientType.LSP))"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.LSP) || !isActiveEdit()">
                  </toggle-button>
                  <toggle-button [show]="showAllToggleButton() || isShowEngagedLetter(ReportClientType.LSP)"
                    icon="paperclip" hint="Send Engagement Letter" [name]="ReportClientType.LSP"
                    [value]="getClientUserByType(ReportClientType.LSP)?.EMAIL_ENGAGE"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_ENGAGE', getClientUserByType(ReportClientType.LSP))"
                    [disabled]="isDisabled || !getClientUserByType(ReportClientType.LSP) || !isActiveEdit()">
                  </toggle-button>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="row"
            *ngFor="let other of (currentReport.CLIENT_USERS | clientUserOther | orderBy: ['ID']); let i = index;">
            <div class="col-sm-10" style="padding-right: 5px;">
              <input-label [type]="typeOfInput.TEXT" placeholder="Other" [inputValue]="other.LABEL"
                (valueChange)="setClientUserOtherLabel($event, other)" [disabled]="isDisabled || !isActiveEdit()">
              </input-label>
              <div class="remove-wrapper">
                <input-search [provider]="clientUserProvider" [showCreate]="true" [createNew]="typesOfData.CLIENT_USER"
                  placeholder="Select Other" [disabled]="isDisabled || !currentReport.CLIENT || !isActiveEdit()"
                  [refresh]="true" [displayFull]="true" [userIcon]="true" [parent-id]="currentReport.CLIENT?.ID"
                  [parent]="currentReport?.CLIENT" [inputValue]="other.CLIENT_USER" [nonBank]="true" [others]="true"
                  [paginated]="true" (valueChange)="selectedClientUserOther(other, $event);">
                </input-search>
                <profile-info [data]="other" [profileInfoType]="ProfileInfoType.CLIENT_USER"
                  [disabled]="isDisabled || !other.CLIENT_USER || !isActiveEdit()"></profile-info>
              </div>
            </div>

            <div class="col-sm-2" style="padding-left: 2px;">
              <div class="toggle-button-row no-label">
                <ng-container *ngIf="currentReport?.CLIENT?.IS_BANK && i === 0">
                  <toggle-button icon="envelope-o" hint="CC on Correspondence"
                    [value]="getClientUserByType(ReportClientType.OTHER)?.EMAIL_CC"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_CC', getClientUserByType(ReportClientType.OTHER))"
                    [disabled]="isDisabled || !other.CLIENT_USER || !isActiveEdit()">
                  </toggle-button>
                  <toggle-button [show]="showAllToggleButton() || isShowEngagedLetter(ReportClientType.OTHER)"
                    icon="paperclip" hint="Send Engagement Letter" [name]="ReportClientType.OTHER"
                    [value]="getClientUserByType(ReportClientType.OTHER)?.EMAIL_ENGAGE"
                    (valueChange)="setClientUserToggle($event, 'EMAIL_ENGAGE', getClientUserByType(ReportClientType.OTHER))"
                    [disabled]="isDisabled || !other.CLIENT_USER|| !isActiveEdit()">
                  </toggle-button>
                </ng-container>

                <button *ngIf="(currentReport?.CLIENT?.IS_BANK && i !== 0 || !currentReport?.CLIENT?.IS_BANK)"
                  [disabled]="isDisabled || !isActiveEdit()" type="button"
                  class="btn btn-rbv warning remove-client-user hinted" (click)="removeClientUser(other)">
                  <fa name="fa fa-ban"></fa>
                  <div class="hint">Remove Bank User</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Engagement Information -->
      <div class="section-block">
        <div class="section-header" (click)="isCollapsed.ENGAGEMENT = !isCollapsed.ENGAGEMENT"
          [attr.aria-expanded]="!isCollapsed.ENGAGEMENT" aria-controls="collapseEvent">
          <fa [name]="isCollapsed.ENGAGEMENT ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text">Engagement Information</div>
        </div>

        <div class="section-content" [collapse]="!isCollapsed.ENGAGEMENT">

          <!-- First Row (Eng letter Sent, Eng Date, Due Date, Anticipated Date) -->
          <div class="row">
            <!-- Eng letter Sent -->
            <div class="col-md-3">
              <label class="rbv-label date-label"
                popover="Engagement Letter Date. The date when Letter is sent out from System to DocuSign."
                triggers="mouseenter:mouseleave">
                Eng Letter Sent
                <span class="help-tooltip">
                  <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                </span>
              </label>
              <input class="rbv-field" [disabled]="isDisabled || !isActiveEdit()"
                [ngClass]="{'input-field': !checkIfIsDue(currentReport.DATE_ENGAGED_LETTER), 'form-control-plaintext': checkIfIsDue(currentReport.DATE_ENGAGED_LETTER)}"
                value="{{currentReport.DATE_ENGAGED_LETTER | date: 'MMM dd, yyyy'}}" readonly />
            </div>

            <!-- Eng Date -->
            <div class="col-md-3">
              <label class="rbv-label date-label" popover="Engagement Date. The date when Client actually signed Letter."
                triggers="mouseenter:mouseleave">
                Engagement Date
                <span class="help-tooltip">
                  <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                </span>
              </label>
              <!-- <input class="rbv-field" [disabled]="isDisabled || !isActiveEdit()"
                [ngClass]="{'input-field': !checkIfIsDue(currentReport.DATE_ENGAGED), 'form-control-plaintext': checkIfIsDue(currentReport.DATE_ENGAGED)}"
                value="{{currentReport.DATE_ENGAGED | date: 'MMM dd, yyyy h:mm a'}}" readonly /> -->

              <div class="anticipated-wrapper">
                <div class="input-wrapper">
                  <input class="rbv-field form-control rounded-0" [(ngModel)]="currentReport.DATE_ENGAGED" disabled />
                </div>
                <div class="button-wrapper">
                  <button type="button" class="close lock-icon calendar" aria-label="Close"
                    [disabled]="isDisabled || !isActiveEdit()" [isDisabled]="isDisabled || !isActiveEdit()"
                    #datePicker="bsDatepicker" bsDatepicker
                    [bsConfig]="{dateInputFormat: 'MMM DD, YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                    [outsideClick]="true" (bsValueChange)="setEngagementDate($event)">
                    <span aria-hidden="true"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Due Date -->
            <div class="col-md-3">
              <label class="rbv-label date-label" popover="Including holidays and weekends" triggers="mouseenter:mouseleave">
                Due Date
                <span class="help-tooltip">
                  <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                </span>
              </label>
              <div class="anticipated-wrapper">
                <div class="input-wrapper">
                  <due-date [disabled]="isDisabled || !isActiveEdit()" [engageDate]="currentReport.DATE_ENGAGED"
                    [turnFrom]="currentReport.TURN_FROM" [dueDate]="currentReport.DATE_DUE"
                    [turnTo]="currentReport.TURN_TO" #dueDate></due-date>
                </div>
                <div class="button-wrapper">
                  <button [disabled]="isDisabled || !isActiveEdit()" type="button" class="close lock-icon calendar"
                    aria-label="Close" [isDisabled]="isDisabled || !isActiveEdit()" #datePicker="bsDatepicker"
                    bsDatepicker
                    [bsConfig]="{dateInputFormat: 'MMM DD, YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                    [outsideClick]="true" (bsValueChange)="setDueDate($event)">
                    <span aria-hidden="true"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                  </button>
                </div>
              </div>

              <!-- <due-date [disabled]="isDisabled || !isActiveEdit()" [engageDate]="currentReport.DATE_ENGAGED"
                        [turnFrom]="currentReport.TURN_FROM" [dueDate]="currentReport.DATE_DUE"
                        [turnTo]="currentReport.TURN_TO" #dueDate></due-date> -->
            </div>

            <!-- Anticipated Date -->
            <div class="col-md-3">
              <label class="rbv-label">Anticipated Date</label>
              <div class="anticipated-wrapper">
                <div class="input-wrapper">
                  <input class="rbv-field form-control rounded-0" [(ngModel)]="currentReport.DATE_ANTICIPATED"
                    #dtAnticipated="bsDatepicker" bsDatepicker placeholder="Anticipated Date"
                    [bsConfig]="{dateInputFormat: 'MMM DD, YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                    (ngModelChange)="setAnticipatedDate()" [outsideClick]="true" readonly="true" />
                </div>
                <div class="button-wrapper">
                  <button type="button" (click)="dtAnticipated.show()" class="close lock-icon calendar"
                    aria-label="Close" *ngIf="!currentReport.DATE_ANTICIPATED"
                    [disabled]="isDisabled || !isActiveEdit()">
                    <span aria-hidden="true"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                  </button>

                  <a class="lock-icon" (click)="clearDateAnticipated()" *ngIf="currentReport.DATE_ANTICIPATED">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Second Row (Purpose, Fee, Turn Time From, Turn Time To) -->
          <div class="row">
            <!-- Fee -->
            <div class="col-md-3">
              <label class="rbv-label date-label" popover="= $2,500 + $300" triggers="mouseenter:mouseleave">Fee
                <span class="help-tooltip">
                  <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                </span>
              </label>
              <entity-charge [report]="currentReport" [disabled]="isDisabled || !isActiveEdit()"></entity-charge>
            </div>

            <!-- Turn Time From -->
            <div class="col-md-3">
              <label class="rbv-label">Turn Time From</label>
              <input-data [disabled]="isDisabled || !isActiveEdit()" [type]="typeOfInput.NUMBER"
                [(ngModel)]="currentReport.TURN_FROM" [provider]="reportProvider" [id]="currentReport.ID"
                [fieldName]="'TURN_FROM'" (onValueTouched)="onValueTouched($event)" [allowNegative]="false"
                [showButton]="showButton"></input-data>
            </div>

            <!-- Turn Time To -->
            <div class="col-md-3">
              <label class="rbv-label">Turn Time To</label>
              <input-data [disabled]="isDisabled || !isActiveEdit()" [type]="typeOfInput.NUMBER"
                [(ngModel)]="currentReport.TURN_TO" [provider]="reportProvider" [id]="currentReport.ID"
                [fieldName]="'TURN_TO'" (onValueTouched)="onValueTouched($event)" [allowNegative]="false"
                [showButton]="showButton"></input-data>
            </div>

            <!-- Effective Date -->
            <div class="col-md-3">
              <label class="rbv-label">Effective Date</label>
              <div class="anticipated-wrapper">
                <div class="input-wrapper">
                  <input class="rbv-field form-control rounded-0" [(ngModel)]="currentReport.DATE_EFFECTIVE"
                    #dtEffective="bsDatepicker" bsDatepicker placeholder="Effective Date"
                    [bsConfig]="{dateInputFormat: 'MMM DD, YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                    (ngModelChange)="setEffectiveDate()" [outsideClick]="true" readonly="true" />
                </div>
                <div class="button-wrapper">
                  <button type="button" (click)="dtEffective.show()" class="close lock-icon calendar" aria-label="Close"
                    *ngIf="!currentReport.DATE_EFFECTIVE">
                    <span aria-hidden="true"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                  </button>

                  <a class="lock-icon" (click)="clearEffectiveDate()" *ngIf="currentReport.DATE_EFFECTIVE">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Third Row (Standard of Value, Type of Valuation, Type of Report) -->
          <div class="row">
            <!-- Purpose -->
            <div class="col-sm-4 col-md-4">
              <label class="rbv-label date-label handle-popover" popover="Assist the client in determining the estate value of the business."
                triggers="mouseenter:mouseleave">
                Purpose
                <span class="help-tooltip">
                  <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                </span>
              </label>
              <input-search [disabled]="isDisabled || !isActiveEdit()" placeholder="Select Purpose"
                [preset]="purposeValues" [userInputAllowed]="true" [inputValue]="currentReport.PURPOSE"
                (valueChange)="purposeChanged($event)"></input-search>
            </div>

            <!-- Type of Valuation -->
            <div class="col-sm-4 col-md-4">
              <label class="rbv-label">Type of Valuation</label>
              <input-search [disabled]="isDisabled || !isActiveEdit()" placeholder="Select Type of Valuation"
                [regular]="true" [preset]="valTypeValues" [inputValue]="currentReport.VALUATION_TYPE"
                (valueChange)="valuationTypeChanged($event)"></input-search>
            </div>

            <!-- Type of Report -->
            <div class="col-sm-4 col-md-4">
              <label class="rbv-label">Type of Report</label>
              <input-search [disabled]="isDisabled || !isActiveEdit()" placeholder="Select Type of Report"
                [regular]="true" [preset]="repTypeValues" [inputValue]="currentReport.REPORT_TYPE"
                (valueChange)="reportTypeChanged($event)">
              </input-search>
            </div>
          </div>

          <div class="row">
            <!-- Standard of Value -->
            <div class="col-sm-12 col-md-12">
              <label class="rbv-label">Standard of Value</label>
              <multiple-input [disabled]="isDisabled || !isActiveEdit()" [preset]="sovValues"
                [arrValue]="currentReport.STANDARD_OF_VALUES" (valueChange)="sofChanged($event)">
              </multiple-input>
            </div>
          </div>

          <!-- Tags -->
          <div class="row">
            <div class="col-sm-12">
              <div class="d-flex align-items-center justify-content-between">
                <label class="rbv-label" [ngClass]="{'mb-0': currentReport.LINKED_REPORTS?.length > 0}">
                  Tags
                </label>

                <!-- Synchronize -->
                <div class="checkbox-item small ml-5" *ngIf="currentReport.LINKED_REPORTS?.length > 0">
                  <input class="checkbox-custom" type='checkbox' name="synchronize" id="synchronize"
                         [(ngModel)]="currentReport.SYNCHRONIZE" (ngModelChange)="isSynchronizeChange($event)"
                         [disabled]="isDisabled || !isActiveEdit()" />
                  <label class="checkbox-custom-label" for="synchronize">
                    Synchronize
                  </label>
                </div>
              </div>

              <tag-search id="REPORT_TAG" name="REPORT_TAG" [provider]="tagProvider" [placeholder]="'Select Tags'"
                          [selectedTags]="currentReport.TAGS" (tagRemoved)="tagRemoved($event)"
                          (tagSelected)="tagSelected($event)" [disabled]="isDisabled || !isActiveEdit()"></tag-search>
            </div>
          </div>

          <!-- Addendum -->
          <div class="row">
            <div class="addendum col-sm-12 col-md-3">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="addendum" id="addendum"
                  [(ngModel)]="currentReport.ADDENDUM" (ngModelChange)="isAddendumChange($event)"
                  [disabled]="isDisabled || !isActiveEdit()">
                <div class="checkbox__data pl-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text">Addendum </p>
                </div>
              </label>
            </div>
          </div>

          <div class="row">
            <div *ngIf="currentReport.ADDENDUM" class="col-sm-12 mt-2">
              <!-- <angular-editor (focusout)="setAddendumContent($event)" [disabled]="isDisabled || !isActiveEdit"
                [(ngModel)]="currentReport.ADDENDUM_CONTENT" [config]="editorConfig"></angular-editor> -->
              <quill-editor name="ADDENDUM_CONTENT" [(ngModel)]="currentReport.ADDENDUM_CONTENT"
                [modules]="quillModules" (focusout)="setAddendumContent($event)"
                [disabled]="isDisabled || !isActiveEdit"></quill-editor>
            </div>
          </div>

        </div>
      </div>

      <!-- Notes and Comments -->
      <div class="section-block">
        <div class="section-header" (click)="isCollapsed.NOTES = !isCollapsed.NOTES"
          [attr.aria-expanded]="!isCollapsed.NOTES" aria-controls="collapseEvent">
          <fa [name]="isCollapsed.NOTES ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text">Notes & Comments</div>
        </div>

        <!-- Collapsed Notes -->
        <div class="section-content" [collapse]="!isCollapsed.NOTES">
          <!-- Order Form Additional Comments -->
          <div class="row" *ngIf="currentReport.NOTES?.length > 0">
            <div class="col-md-12">
              <label class="rbv-label">Order Form Additional Comments</label>
              <textarea rows="5" class="form-control notes rounded-0 rbv-field" [(ngModel)]="currentReport.NOTES"
                placeholder="Order Notes" [disabled]="true" (blur)="setNotesField($event)"></textarea>
            </div>
          </div>

          <!-- Notes and Comments -->
          <div class="row">
            <div class="col-md-12">
              <label class="rbv-label">Notes and Comments</label>
              <textarea rows="5" class="form-control notes rounded-0 rbv-field" [(ngModel)]="currentReport.COMMENTS"
                placeholder="Notes and Comments" [disabled]="isDisabled || !isActiveEdit()"
                (blur)="setNotesField($event)"></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- Reliant Responsible Party -->
      <div class="section-block">
        <div class="section-header" (click)="isCollapsed.USERS = !isCollapsed.USERS"
          [attr.aria-expanded]="!isCollapsed.USERS" aria-controls="collapseEvent">
          <fa [name]="isCollapsed.USERS ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text">Reliant Responsible Party</div>
        </div>

        <!-- Collapsed Data -->
        <div class="section-content" [collapse]="!isCollapsed.USERS">

          <!-- Equipment Processor -->
          <div class="row">
            <div class="col-sm-11" style="padding-right: 5px;">
              <label class="rbv-label">Equipment Processor</label>
              <input-search [position]="ReportUserType.EQUIPMENT_PROCESSOR" [provider]="userProvider"
                placeholder="Select Equipment Processor"
                [inputValue]="currentReport.getUsers()['EQUIPMENT_PROCESSOR']?.USER" [refresh]="true"
                (valueChange)="selectedUser(ReportUserType.EQUIPMENT_PROCESSOR, $event);"></input-search>
            </div>

            <div class="col-sm-1" style="padding-left: 2px;">
              <div class="toggle-button-row no-label">
                <profile-info [data]="currentReport.getUsers()['EQUIPMENT_PROCESSOR']"
                  [profileInfoType]="ProfileInfoType.USER"
                  [disabled]="!currentReport.getUsers()['EQUIPMENT_PROCESSOR']?.USER"></profile-info>
              </div>
            </div>
          </div>

          <!-- Equipment Research Analyst -->
          <div class="row">
            <div class="col-sm-11" style="padding-right: 5px;">
              <label class="rbv-label">Equipment Research Analyst</label>
              <input-search [position]="ReportUserType.EQUIPMENT_RESEARCH_ANALYST" [provider]="userProvider"
                placeholder="Select Equipment Research Analyst"
                [inputValue]="currentReport.getUsers()['EQUIPMENT_RESEARCH_ANALYST']?.USER" [refresh]="true"
                (valueChange)="selectedUser(ReportUserType.EQUIPMENT_RESEARCH_ANALYST, $event);"></input-search>
            </div>

            <div class="col-sm-1" style="padding-left: 2px;">
              <div class="toggle-button-row no-label">
                <profile-info [data]="currentReport.getUsers()['EQUIPMENT_RESEARCH_ANALYST']"
                  [profileInfoType]="ProfileInfoType.USER"
                  [disabled]="!currentReport.getUsers()['EQUIPMENT_RESEARCH_ANALYST']?.USER"></profile-info>
              </div>
            </div>
          </div>

          <!-- Equipment Appraiser -->
          <div class="row">
            <div class="col-sm-11" style="padding-right: 5px;">
              <label class="rbv-label">Equipment Appraiser</label>
              <input-search [position]="ReportUserType.EQUIPMENT_APPRAISER" [provider]="userProvider"
                placeholder="Select Equipment Appraiser"
                [inputValue]="currentReport.getUsers()['EQUIPMENT_APPRAISER']?.USER" [refresh]="true"
                (valueChange)="selectedUser(ReportUserType.EQUIPMENT_APPRAISER, $event);"></input-search>
            </div>
            <div class="col-sm-1" style="padding-left: 2px;">
              <div class="toggle-button-row no-label">
                <profile-info [data]="currentReport.getUsers()['EQUIPMENT_APPRAISER']"
                  [profileInfoType]="ProfileInfoType.USER"
                  [disabled]="!currentReport.getUsers()['EQUIPMENT_APPRAISER']?.USER"></profile-info>
              </div>
            </div>
          </div>

          <!-- Equipment Reviewer -->
          <div class="row">
            <div class="col-sm-11" style="padding-right: 5px;">
              <label class="rbv-label">Equipment Reviewer</label>
              <input-search [position]="ReportUserType.EQUIPMENT_REVIEWER" [provider]="userProvider"
                placeholder="Select Equipment Reviewer"
                [inputValue]="currentReport.getUsers()['EQUIPMENT_REVIEWER']?.USER" [refresh]="true"
                (valueChange)="selectedUser(ReportUserType.EQUIPMENT_REVIEWER, $event);"></input-search>
            </div>
            <div class="col-sm-1" style="padding-left: 2px;">
              <div class="toggle-button-row no-label">
                <profile-info [data]="currentReport.getUsers()['EQUIPMENT_REVIEWER']"
                  [profileInfoType]="ProfileInfoType.USER"
                  [disabled]="!currentReport.getUsers()['EQUIPMENT_REVIEWER']?.USER"></profile-info>
              </div>
            </div>
          </div>

          <!-- Equipment Submitter -->
          <div class="row">
            <div class="col-sm-11" style="padding-right: 5px;">
              <label class="rbv-label">Equipment Submitter</label>
              <input-search [position]="ReportUserType.EQUIPMENT_SUBMITTER" [provider]="userProvider"
                placeholder="Select Equipment Submitter"
                [inputValue]="currentReport.getUsers()['EQUIPMENT_SUBMITTER']?.USER" [refresh]="true"
                (valueChange)="selectedUser(ReportUserType.EQUIPMENT_SUBMITTER, $event);"></input-search>
            </div>
            <div class="col-sm-1" style="padding-left: 2px;">
              <div class="toggle-button-row no-label">
                <profile-info [data]="currentReport.getUsers()['EQUIPMENT_SUBMITTER']"
                  [profileInfoType]="ProfileInfoType.USER"
                  [disabled]="!currentReport.getUsers()['EQUIPMENT_SUBMITTER']?.USER"></profile-info>
              </div>
            </div>
          </div>

          <!-- Other -->
          <div class="row">
            <div class="col-sm-11" style="padding-right: 5px;">
              <input-label [type]="typeOfInput.TEXT" placeholder="Other" [disabled]="isDisabled || !isActiveEdit()">
              </input-label>
              <input-search [provider]="userProvider" placeholder="Select Other"
                [inputValue]="currentReport.getUsers()['OTHER']?.USER" [refresh]="true"
                (valueChange)="selectedUser(ReportUserType.OTHER, $event);"></input-search>
            </div>
            <div class="col-sm-1" style="padding-left: 2px;">
              <div class="toggle-button-row no-label">
                <profile-info [data]="currentReport.getUsers()['OTHER']" [profileInfoType]="ProfileInfoType.USER"
                  [disabled]="!currentReport.getUsers()['OTHER']?.USER"></profile-info>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="col-md-4">
      <!-- Summary -->
      <div class="section-block">
        <!-- Title -->
        <div class="section-header" (click)="isCollapsed.SUMMARY = !isCollapsed.SUMMARY"
          [attr.aria-expanded]="!isCollapsed.SUMMARY" aria-controls="collapseEvent">
          <fa [name]="isCollapsed.SUMMARY ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text">Summary</div>
        </div>

        <!-- Summary Collapsed Data -->
        <div class="report-summary" [collapse]="!isCollapsed.SUMMARY">
          <!-- Report Number -->
          <div class="row" *ngIf="currentReport?.PROJECT_NUMBER">
            <div class="col-5">
              <div class="label">Report Number:</div>
            </div>
            <div class="col-7">
              <div class="stage value">
                {{currentReport.PROJECT_NUMBER}}
              </div>
            </div>
          </div>

          <!-- Assignee -->
          <div class="row">
            <div class="col-5">
              <div class="label">Assignee:</div>
            </div>
            <div class="col-7">
              <div class="user value">
                <ngx-avatar [name]="currentReport.ASSIGNEE?.getName()" size="20" *ngIf="currentReport.ASSIGNEE">
                </ngx-avatar>
                <div class="user-name" [ngClass]="{'no-assignee': !currentReport.ASSIGNEE}">
                  {{currentReport.ASSIGNEE ? currentReport.ASSIGNEE.getName(): 'No Assignee'}}
                  <i class="fa fa-edit" tooltip="Change Assignee" (click)="changeAssignee()"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Stage -->
          <div class="row">
            <div class="col-5">
              <div class="label">Stage:</div>
            </div>
            <div class="col-7">
              <div class="stage value" (click)="changeStage()">
                {{currentReport.STAGE?.NAME}}
              </div>
            </div>
          </div>

          <!-- State -->
          <div class="row">
            <div class="col-5">
              <div class="label">State:</div>
            </div>
            <div class="col-7">
              <div class="state value">
                {{currentReport.STATE?.NAME}}
              </div>
            </div>
          </div>

          <!-- Created Date -->
          <div class="row">
            <div class="col-5">
              <div class="label">Created:</div>
            </div>
            <div class="col-7">
              <div class="date value hinted">
                {{currentReport.DATE_CREATED | amTimeAgo}}
                <div class="hint">{{currentReport.DATE_CREATED | date: 'MM/dd/yy hh:mm:ss a'}}</div>
              </div>
            </div>
          </div>

          <!-- Updated Date -->
          <div class="row">
            <div class="col-5">
              <div class="label">Updated:</div>
            </div>
            <div class="col-7">
              <div class="date value">
                {{currentReport.DATE_UPDATED | amTimeAgo}}
              </div>
            </div>
          </div>

          <!-- Value Assessment -->
          <div class="row" *ngIf="currentReport?.VALUE_ASSESSMENT">
            <div class="col-5">
              <div class="label">Value Assessment:</div>
            </div>
            <div class="col-7">
              <div class="stage value">
                {{currentReport.VALUE_ASSESSMENT === 'VALUE' ? 'Value' : (currentReport.VALUE_ASSESSMENT === 'NOT_VALUE' ? 'Not Value' : 'N/A')}}
              </div>
            </div>
          </div>

          <!-- Research User -->
          <div class="row">
            <div class="col-5">
              <div class="label">Researched:</div>
            </div>
            <div class="col-7">
              <div class="user value">
                <ng-container *ngIf="currentReport.R_RESEARCH">
                  <ngx-avatar [name]="currentReport.R_RESEARCH?.getName()" size="20"></ngx-avatar>
                  <div class="user-name">
                    {{currentReport.R_RESEARCH.getName()}}
                    <i class="fa fa-edit" tooltip="Change Researched" (click)="changeResearched()"></i>
                  </div>
                </ng-container>

                <button *ngIf="!currentReport.R_RESEARCH" class="btn btn-rbv btn-block researched-btn"
                  (click)="setResearched()">Set</button>
              </div>
            </div>
          </div>

          <!-- Spread User -->
          <div class="row">
            <div class="col-5">
              <div class="label">Spreaded:</div>
            </div>
            <div class="col-7">
              <div class="user value">
                <ng-container *ngIf="currentReport.R_SPREAD">
                  <ngx-avatar [name]="currentReport.R_SPREAD?.getName()" size="20"></ngx-avatar>
                  <div class="user-name">
                    {{currentReport.R_SPREAD.getName()}}
                    <i class="fa fa-edit" tooltip="Change Spreaded" (click)="changeSpreaded()"></i>
                  </div>
                </ng-container>

                <button *ngIf="!currentReport.R_SPREAD" class="btn btn-rbv btn-block researched-btn"
                  (click)="setSpreaded()">Set</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Stage History -->
        <div class="section-block">
          <div class="section-header full" [attr.aria-expanded]="!isCollapsed.STAGE" aria-controls="collapseEvent">
            <fa [name]="isCollapsed.STAGE ? 'fa fa-minus' : 'fa fa-plus'"
              (click)="isCollapsed.STAGE = !isCollapsed.STAGE"></fa>
            <div class="text" (click)="isCollapsed.STAGE = !isCollapsed.STAGE">Stage Progress</div>
            <div class="actions">
              <button class="btn btn-rbv opaque hinted" (click)="stagesCompact = !stagesCompact"
                [ngClass]="{'active': stagesCompact}">
                <fa name="fa fa-compress"></fa>
                <div class="hint">Show Transitions Only</div>
              </button>
            </div>
          </div>

          <div class="report-staging" *ngIf="stages" [collapse]="!isCollapsed.STAGE">
            <ul class="report-staging_items">
              <stage-info *ngFor="let stage of stages | orderBy : ['ORDER']" [compact]="stagesCompact"
                [stageList]="stagesList" [stage]="stage" [currentStage]="currentReport.STAGE"
                [currentReport]="currentReport"></stage-info>
            </ul>
          </div>
        </div>

        <!-- Engagement Letter -->
        <div class="section-block">
          <div class="section-header" (click)="isCollapsed.ENGAGE = !isCollapsed.ENGAGE"
            [attr.aria-expanded]="!isCollapsed.ENGAGE" aria-controls="collapseEvent">
            <fa [name]="isCollapsed.ENGAGE ? 'fa fa-minus' : 'fa fa-plus'"></fa>
            <div class="text">Engagement</div>
          </div>

          <div [collapse]="!isCollapsed.ENGAGE">
            <div class="validation" *ngIf="!isDisabled">
              <!-- Engagement Information -->
              <ng-container *ngIf="currentReport.validateAll; let rev">
                <div class="validation-block" [ngClass]="{'success': rev.length === 0}">
                  <div class="indicator"></div>

                  <div class="info">
                    <div class="header">Engagement Information</div>

                    <div class="description" *ngIf="rev.length === 0">
                      All Checks are Passed
                    </div>

                    <div class="error" *ngFor="let err of rev">
                      <ng-container *ngIf="err === 'Client User has no Name' || err === 'Client User has no Name' || err === 'Client User has no Lastname' || err === 'Client User has no Email Address' ||
                    err === 'Client User has no Address' || err === 'Client User has no City' || err === 'Client User has no State' ||
                    err === 'Client User has no Zip'; else nextError">
                        - <a (click)="onEditClientUser()" class="error" href="javascript:void(0)">{{err}}</a>
                      </ng-container>


                      <ng-template #nextError>
                        - {{err}}
                      </ng-template>

                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- Effective Date -->
              <ng-container *ngIf="currentReport.validateEffectiveDate; let pav">
                <div class="validation-block" [ngClass]="{'success': pav.length === 0}">
                  <div class="indicator"></div>

                  <div class="info">
                    <div class="header">Effective Date</div>

                    <div class="description" *ngIf="pav.length === 0">
                      All Checks are Passed
                    </div>

                    <div class="error" *ngFor="let err of pav">
                      - {{err}}
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="currentReport?.STAGE?.ORDER < 4 || !isDisabled">
                <ng-container
                  *ngIf="currentReport.validateEffectiveDate.length == 0 && currentReport.isValid; then ready else notReady">
                </ng-container>
              </ng-container>

              <!-- Ready to Engage -->
              <ng-template #ready>
                <div class="validation-result">
                  <fa name="fa fa-check-circle"></fa>
                  <div class="text">Ready to Engage</div>
                </div>
              </ng-template>

              <!-- Not Ready to Engage -->
              <ng-template #notReady>
                <div class="validation-result error">
                  <fa name="fa fa-exclamation-triangle"></fa>
                  <div class="text">Not Ready to Engage</div>
                </div>
              </ng-template>

              <!-- <div class="validation-actions">
                <ng-container *ngIf="currentReport?.STAGE?.ORDER < 4 || !isDisabled">
                  <button type=" button" class="btn btn-rbv primary full-width"
                    [disabled]="!isActiveEdit() || !(currentReport.validateEffectiveDate.length == 0 && currentReport.isValid)"
                    (click)="showEngage()">
                    Engage via <img src="/assets/images/docusign.png" style="height: 24px;" />
                  </button>

                  <button type="button" class="btn btn-rbv warning full-width" (click)="showEngageManual()"
                    [disabled]="!isActiveEdit() || !(currentReport.validateEffectiveDate.length == 0 && currentReport.isValid) || isEngageModalOpen">
                    Engage Without DocuSign
                  </button>
                </ng-container>

                <button type="button" *ngIf="currentReport?.INITIAL_SENT !== true" class="btn btn-rbv full-width"
                  (click)="openRequestModal()" style="margin-top: 10px;">
                  Initial Email (No Engagement Letter)
                </button>
              </div> -->
            </div>

            <!-- Actions -->
            <div class="report-actions">
              <button type=" button" class="btn btn-rbv primary full-width"
                    [disabled]="!isActiveEdit() || !(currentReport.validateEffectiveDate.length == 0 && currentReport.isValid)"
                    (click)="showEngage()">
                    Engage via <img src="/assets/images/docusign.png" style="height: 24px;" />
                  </button>

                  <button type="button" class="btn btn-rbv warning full-width" (click)="showEngageManual()"
                    [disabled]="!isActiveEdit() || !(currentReport.validateEffectiveDate.length == 0 && currentReport.isValid) || isEngageModalOpen"
                    style="margin-top: 10px;">
                    Engage Without DocuSign
                  </button>

                  <button type="button" *ngIf="!isDisabled || (currentReport?.STAGE?.ORDER < 4 && currentReport?.INITIAL_SENT !== true)" class="btn btn-rbv full-width"
                  (click)="openRequestModal()" style="margin-top: 10px;">
                  Initial Email (No Engagement Letter)
                </button>

              <button
                [disabled]="!(currentReport.validateEffectiveDate.length == 0 && currentReport.isValid) || isLoadingPreview"
                type="button" class="btn btn-rbv full-width" (click)="onDownloadPdf()" style="margin-top: 10px;">
                <span class="loading-icon-small" *ngIf="isLoadingPreview"></span>
                Download Engagement Letter
              </button>

              <button *ngIf="currentReport?.STAGE?.ID === 'EALS' || currentReport?.STAGE?.ID === 'EALR'" type="button"
                class="btn btn-rbv warning full-width" (click)="engageFile()" style="margin-top: 10px;">
                Engage File
              </button>
            </div>
          </div>
        </div>

        <!-- Site Visit Scheduled Letter -->
        <div class="section-block" *ngIf="currentReport?.STAGE?.ID === 'EASCH'">
          <div class="section-header" (click)="isCollapsed.SITE_VISIT = !isCollapsed.SITE_VISIT"
               [attr.aria-expanded]="!isCollapsed.SITE_VISIT" aria-controls="collapseSiteVisit">
            <fa [name]="isCollapsed.SITE_VISIT ? 'fa fa-minus' : 'fa fa-plus'"></fa>
            <div class="text">Site Visit</div>
          </div>

          <div [collapse]="!isCollapsed.SITE_VISIT">
            <div class="report-actions" style="margin-top: 10px;">
              <button type="button"
                      class="btn btn-rbv primary full-width"
                      [disabled]="!isSiteVisitStage() || isSiteVisitModalOpen"
                      (click)="scheduleSiteVisitEmail()">
                Schedule Site Visit Email
              </button>
            </div>
          </div>
        </div>

        <!--Documents-->
        <div class="section-block" *ngIf="currentReport.DOCUMENTS">
          <div class="section-header" (click)="isCollapsed.DOCUMENTS = !isCollapsed.DOCUMENTS"
            [attr.aria-expanded]="!isCollapsed.DOCUMENTS" aria-controls="collapseEvent">
            <fa [name]="isCollapsed.DOCUMENTS ? 'fa fa-minus' : 'fa fa-plus'"></fa>
            <div class="text">Documents</div>
          </div>

          <div class="report-summary" [collapse]="!isCollapsed.DOCUMENTS">
            <div class="document-wrapper" *ngFor="let doc of currentReport.DOCUMENTS">
              <!-- Document-->
              <div class="row">
                <div class="col-4 column">
                  <div class="label">Document:</div>
                </div>
                <div class="col-6 column" [ngSwitch]="doc.DOCUMENT_TYPE">
                  <div class="value" *ngSwitchCase="DocumentType.ENGAGEMENT_LETTER">
                    Engagement Letter
                  </div>
                </div>

                <div class="col-1 column">
                  <div class="btn-rbv-dropdown" dropdown>
                    <button dropdownToggle type="button" class="btn-option">
                      <i class="fa fa-cog" style="font-size: 20px; color: gray;"></i>
                    </button>

                    <div *dropdownMenu class="drop-menu dropdown-menu-right" style="width: 200px;">
                      <a class="drop-item" (click)="downloadDocumentZip($event, doc)">
                        <i class="fa fa-file-archive-o" *ngIf="!doc.disabled"></i>
                        <span class="loading-icon-small" *ngIf="doc.disabled"></span>
                        <div class="item">Download Zip</div>
                      </a>

                      <a class="drop-item" (click)="downloadDocument($event, doc)">
                        <i class="fa fa-file-pdf-o" *ngIf="!doc.disabled"></i>
                        <span class="loading-icon-small" *ngIf="doc.disabled"></span>
                        <div class="item">Download Combined</div>
                      </a>

                      <a class="drop-item" *ngIf="doc.DOCUMENT_STATE !== RSState.executed" (click)="voidDocument(doc)">
                        <i class="fa fa-ban" style="color: red"></i>
                        <div class="item">Void Document</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-4">
                  <div class="label">State:</div>
                </div>

                <div class="col-6">
                  <div *ngIf="!doc.IS_MANUAL" [ngSwitch]="doc.DOCUMENT_STATE">
                    <div class="state value" *ngSwitchCase="RSState.draft">
                      Draft
                    </div>
                    <div class="state value" *ngSwitchCase="RSState.pending">
                      Pending
                    </div>
                    <div class="state value" *ngSwitchCase="RSState.executed">
                      Executed
                    </div>
                    <div class="state value" *ngSwitchCase="RSState.voided">
                      Voided
                    </div>
                    <div class="state value" *ngSwitchCase="RSState.expired">
                      Expired
                    </div>
                  </div>
                  <span *ngIf="doc.IS_MANUAL" style="font-weight: bold;color: red;">Engaged Manually</span>
                </div>

                <!-- <div class="col-2">
                  <custom-download-preview [previewOnly]="true" [report]="currentReport"></custom-download-preview>
                </div> -->
              </div>

              <!-- Created -->
              <div class="row">
                <div class="col-4">
                  <div class="label">Created:</div>
                </div>
                <div class="col-7">
                  <div class="date value hinted">
                    {{doc.SUBMIT_DATE | amTimeAgo}}
                    <div class="hint">{{currentReport.SUBMIT_DATE | date: 'MM/dd/yy hh:mm:ss a'}}</div>
                  </div>
                </div>
              </div>

              <!-- Executed -->
              <div class="row" *ngIf="doc.DOCUMENT_STATE === RSState.executed">
                <div class="col-4">
                  <div class="label">Executed:</div>
                </div>
                <div class="col-7">
                  <div class="date value hinted">
                    {{doc.EXECUTE_DATE | amTimeAgo}}
                    <div class="hint">{{doc.EXECUTE_DATE | date: 'MM/dd/yy hh:mm:ss a'}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Delay History -->
        <div class="section-block" *ngIf="currentReport.DELAYS">
          <div class="section-header" (click)="isCollapsed.DELAY = !isCollapsed.DELAY"
            [attr.aria-expanded]="!isCollapsed.DELAY" aria-controls="collapseEvent">
            <fa [name]="isCollapsed.DELAY ? 'fa fa-minus' : 'fa fa-plus'"></fa>
            <div class="text">Delay History</div>
          </div>

          <div class="report-delays" [collapse]="!isCollapsed.DELAY">
            <div class="delay" *ngFor="let delay of currentReport.DELAYS | orderBy: ['-DATE_START']"
              [ngClass]="{'not-ended': !delay.DATE_END}">
              <div class="record">
                <div class="title">Started</div>
                <div class="date">{{delay.DATE_START | date: 'MM/dd/yy hh:mm a'}}</div>
                <div class="user" *ngIf="delay.USER_START">
                  By: <strong>{{delay.USER_START?.FIRST_NAME+' '+delay.USER_START.LAST_NAME}}</strong>
                </div>
              </div>

              <div class="delay-separator" *ngIf="delay.DATE_END">
                <fa name="fa fa-arrows-h"></fa>
              </div>

              <div class="record ended" *ngIf="delay.DATE_END">
                <div class="title">Ended</div>
                <div class="date">{{delay.DATE_END | date: 'MM/dd/yy hh:mm a'}}</div>
                <div class="user" *ngIf="delay.USER_END">
                  By: <strong>{{delay.USER_END?.FIRST_NAME+' '+delay.USER_END.LAST_NAME}}</strong>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Follow ups -->
        <div class="section-block" *ngIf="currentReport?.STAGE.ORDER < 6">
          <div class="section-header" (click)="isCollapsed.FOLLOW_UP = !isCollapsed.FOLLOW_UP"
            [attr.aria-expanded]="!isCollapsed.FOLLOW_UP" aria-controls="collapseEvent">
            <fa [name]="isCollapsed.FOLLOW_UP ? 'fa fa-minus' : 'fa fa-plus'"></fa>
            <div class="text">Follow Ups</div>
          </div>

          <div class="report-followUp" [collapse]="!isCollapsed.FOLLOW_UP">

            <div class="follow" *ngFor="let fu of currentReport.FOLLOW_UPS">

              <div class="wrapper">
                <div class="record">
                  <div class="date">{{fu.DATE_CREATED | date: 'MM/dd/yy hh:mm a'}}</div>
                </div>
                <div class="record ended">
                  <div class="user" *ngIf="fu.USER">
                    By: <strong>{{fu.USER?.getName()}}</strong>
                  </div>
                </div>
              </div>

              <div class="reason">
                <b>Note: </b> {{fu.NOTE}}
              </div>

            </div>

            <button class="btn btn-rbv btn-block mt-3" (click)="followUp()">Follow Up</button>
          </div>
        </div>

        <!-- Linked Reports -->
        <div class="section-block" *ngIf="currentReport?.LINKED_REPORTS?.length > 0">
          <!-- Header -->
          <div class="section-header" (click)="isCollapsed.LINKED_REPORT = !isCollapsed.LINKED_REPORT"
            [attr.aria-expanded]="!isCollapsed.LINKED_REPORT" aria-controls="collapseEvent">
            <fa [name]="isCollapsed.LINKED_REPORT ? 'fa fa-minus' : 'fa fa-plus'"></fa>
            <div class="text">Linked Reports</div>
          </div>

          <!-- Data -->
          <div class="report-followUp" [collapse]="!isCollapsed.LINKED_REPORT">
            <!-- Link Report -->
            <div class="report-link" *ngFor="let report of currentReport?.LINKED_REPORTS">
              <div class="row d-flex align-items-center justify-content-between m-0">
                <div class="col-md-12 pl-0 pr-4">
                  <!-- Unlink -->
                  <i class="fa fa-close report-unlink" (click)="unlinkReport(report)" *ngIf="!report.isLoading"></i>

                  <!-- Company Name -->
                  <div class="overflow-hidden font-weight-bold cursor-pointer" (click)="goToReport(report)"
                    [ngClass]="{'opacity-half': report.isLoading}">
                    {{report?.COMPANY_NAME}}

                    <!-- Loading -->
                    <div class="report-loading">
                      <div *ngIf="report.isLoading" class="large loading-wrapper">
                        <span class="loading-icon-small" style="display: inline-table;"></span>
                      </div>
                    </div>
                  </div>

                  <!-- Stage Name -->
                  <div class="overflow-hidden" style="font-size: 12px;;">
                    {{report?.STAGE?.NAME}}
                  </div>

                  <!-- State Name -->
                  <div class="overflow-hidden" style="color: orange; font-size: 12px;">
                    {{report?.STATE?.NAME}}
                  </div>
                </div>
              </div>
            </div>

            <!-- Link Report Button -->
            <button class="btn btn-rbv btn-block mt-3" (click)="linkReport()">Link Report</button>
          </div>
        </div>

        <!--Link Report-->
        <div class="section-block" *ngIf="currentReport?.LINKED_REPORTS?.length <= 0">
          <!-- Header -->
          <div class="section-header full">
            <i class="fa fa-retweet" style="font-size: 14px;padding-top: 5px;"></i>
            <div class="text">Linked Reports</div>
            <div class="actions">
              <button class="btn btn-rbv opaque hinted" (click)="linkReport()">
                <fa name="fa fa-plus"></fa>
                <div class="hint">Link Reports</div>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<template #target></template>
